import Enums from "../../../enums/enums";
const state = {
  userInAppSuggestionLoadingStatus: Enums.LoadingStatusType.None,
  userInAppSuggestion: null,
  userInAppTutorial: false,
  userInAppManualGuide: false,
  shouldShowInAppManualGuide: true,
  onScreenFirstLoad: false,
  userInAppTourDocumentTour: {
    show: false,
    step: Enums.DocumentTour.Receipt,
  },
  userInAppPeakExpSettings: false,
};

const getters = {
  GetUserInAppSuggestionLoadingStatus: (state) => {
    return state.userInAppSuggestionLoadingStatus;
  },
  GetUserInAppSuggestion: (state) => {
    return state.userInAppSuggestion;
  },
  GetInAppTutorial: (state) => {
    return state.userInAppTutorial;
  },
  GetInAppManualGuide: (state) => {
    return state.userInAppManualGuide;
  },
  GetShouldShowInAppManualGuide: (state) => {
    return state.shouldShowInAppManualGuide;
  },
  GetOnScreenFirstLoad: (state) => {
    return state.onScreenFirstLoad;
  },
  GetInAppDocumentTour: (state) => {
    return state.userInAppTourDocumentTour;
  },
  GetInAppPeakExpSettings: (state) => {
    return state.userInAppPeakExpSettings;
  },
};
export { getters, state };

